import { listarTipoAtividadesController } from "../../../../../Controllers/Geral/TipoAtividades";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { ITipoAtividades } from "../../../../../Interfaces/Geral/TipoAtividades";
import { useRef, useState } from "react";
import CreateUpdateTipoAtividades from "./CreateUpdateTipoAtividades";
import ListagemTipoAtividades from "./ListagemTipoAtividades";
import { Collapse } from "react-bootstrap";
import { IPropsTableChange } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

export default function TipoAtividades() {
    const [editting, setEditting] = useState<ITipoAtividades>();

    const [pesquisaText, setPesquisaText] = useState("");

    const ultimaPesquisaRef = useRef("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                ultimaPesquisaRef.current = newState.searchText;
            }
        }, 1500);
    }

    const {
        value: lstTipoAtividades,
        loading: lstTipoAtividadesLoading,
        execute: listarTipoAtividades,
    } = useAsyncEffect(async () => {
        return listarTipoAtividadesController(0, ultimaPesquisaRef.current);
    }, [ultimaPesquisaRef.current]);

    function updateListTipoAtividades() {
        listarTipoAtividades();
        setEditting(undefined);
    }

    function Edit(toEdit: ITipoAtividades) {
        if (editting?.ID_TIPO_ATIVIDADE === toEdit.ID_TIPO_ATIVIDADE)
            setEditting(undefined);
        else if (!editting) {
            setEditting(toEdit);
        } else {
            setEditting(undefined);
            setTimeout(() => {
                setEditting(toEdit);
            }, 500);
        }
    }

    return (
        <>
            <div className="col-12 collapse mb-5" id="collapseForm">
                <CreateUpdateTipoAtividades
                    onSave={() => {
                        updateListTipoAtividades();
                    }}
                />
            </div>
            <div className="w-100">
                <ListagemTipoAtividades
                    lstTipoAtividades={lstTipoAtividades}
                    lstTipoAtividadesLoading={lstTipoAtividadesLoading}
                    setEdit={Edit}
                    updateListTipoAtividades={updateListTipoAtividades}
                    pesquisaText={pesquisaText}
                    setPesquisaText={setPesquisaText}
                    handleSearch={handleSearch}
                />
            </div>
            <Collapse in={!!editting} mountOnEnter unmountOnExit>
                <CreateUpdateTipoAtividades
                    tipoAtividade={editting}
                    onSave={() => {
                        updateListTipoAtividades();
                    }}
                />
            </Collapse>
        </>
    );
}
